import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const SENTRY_DSN =
  import.meta.env.VITE_SENTRY_DSN ??
  "https://4a9d1eb1f90edf33033bd7d72a7b2dab@o4511638120693760.ingest.us.sentry.io/4511693563232256";

if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: import.meta.env.MODE,
    // Only send events in production builds to avoid noise from local dev.
    enabled: import.meta.env.PROD,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Performance monitoring: capture a sample of transactions.
    tracesSampleRate: 0.1,
    // Session Replay: sample rate for all sessions, and always on error.
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById("root")!).render(<App />);
